export default class JsFunction {
  inputData = {};

  outputData = {};

  functionName = '';

  importStatement = '';

  apiInstance = '';

  functionality = '';

  functionNextTemplate = '';

  compId = '';

  methodType = 'generic';

  nextFunction;

  htmlTagsToAttributes = new Map([
    ['div', 'textContent'],
    ['label', 'value'],
    ['input', 'value'],
    ['textarea', 'value'],
    ['span', 'textContent'],
    ['p', 'textContent'],
    ['h1', 'textContent'],
    ['h2', 'textContent'],
    ['h3', 'textContent'],
    ['h4', 'textContent'],
    ['h5', 'textContent'],
    ['h6', 'textContent'],
    ['li', 'textContent'],
    ['td', 'textContent'],
    ['img', 'src'],
    ['select', 'value']
  ]);

  pageName = '';

  transitionById;

  annotations;

  constructor(method, annotations) {
    this.inputData = method.inputData || {};
    this.outputData = method.outputData || {};
    this.functionName = method.functionName || '';
    this.importStatement = method.importStatement || '';
    this.apiInstance = method.apiInstance || '';
    this.functionality = method.functionality || '';
    this.functionNextTemplate = method.functionNextTemplate || '';
    this.compId = method.compId || '';
    this.methodType = method.methodType || 'generic';
    this.pageName = method.pageName || '';
    this.annotations = annotations;
    this.transitionById = method.transitionById || false;
  }

  setNextFunction(nextfunction) {
    this.nextFunction = nextfunction;
  }

  toString() {
    return `
    ${JSON.stringify(this.inputData)}
    ${JSON.stringify(this.outputData)}
    ${JSON.stringify(this.functionName)}
    ${JSON.stringify(this.importStatement)}
    ${JSON.stringify(this.functionality)}
    ${JSON.stringify(this.functionInnerTemplate)}
    ${JSON.stringify(this.compId)}
    `;
  }

  printImportStatement() {
    return this.importStatement;
  }

  printFunction() {
    return this.functionality;
  }

  clearfunctionNextTemplate() {
    if (this.functionNextTemplate)
      this.functionality = this.functionality.replace(this.functionNextTemplate, '');
  }

  getMapOfEntitiesToAttributes() {
    return this.annotations[0].combinations
      .filter((combination) => combination.annotationType === 'attribute')
      .reduce((entitiesAttrMap, combination) => {
        if (!entitiesAttrMap.has(combination.annotationLink))
          return entitiesAttrMap.set(combination.annotationLink, [combination.annotationName]);
        const attrArray = entitiesAttrMap.get(combination.annotationLink);
        attrArray.push(combination.annotationName);
        return entitiesAttrMap.set(combination.annotationLink, attrArray);
      }, new Map());
  }

  returnAttributeType(attr) {
    return this.annotations[0].combinations
      .filter((annotation) => annotation.annotationName === attr)
      .map((annotation) => annotation.attributeType)[0];
  }

  isTable(attr) {
    return this.annotations[0].combinations
      .filter((annotation) => annotation.annotationName === attr)
      .map((annotation) => annotation.annotationTable)[0];
  }
}
